module.exports = __webpack_public_path__ + "static/fipcbluedinosaurmain-6ca8133ac3a57bf654b122037db13770.jpeg";